<template>
	<div class="grid-flex-container">
		<WorkbookReportPreviewToolbar
			:reportName="reportName"
			:hasFilters="hasFilters"
			:quickFilter="quickFilter"
			:advancedFilter="advancedFilter"
			:visibleColumns="filterColumns"
			:advancedFiltersCount="advancedFiltersCount"
			@quickFilterChanged="onQuickFilterChanged"
			@advancedFilterChanged="onAdvancedFilterChanged"
		/>

		<div class="generic-grid-container" v-if="hasFilters">
			<grid-view
				v-if="visibleColumns"
				:gridData="gridData"
				:irisUserMetadata="irisUserMetadata"
				:loadingData="loadingData"
				:visibleColumns="visibleColumns"
				:sorting="sorting"
				:page="page"
				:rowsPerPage="rowsPerPage"
				:totalCount="totalCount"
				:hasActions="false"
				@rowsPerPageChanged="onRowsPerPageChanged"
				@pageChanged="onPageChanged"
				@sortChanged="onSortChanged"
			>
				<template v-slot:[`actionsColumns`]> </template>
			</grid-view>
		</div>

		<div class="generic-grid-container" v-else>
			<v-data-table
				:footer-props="{
					itemsPerPageOptions: [10, 15, 20, 25, 30, 50, 100],
					showFirstLastPage: true,
					showCurrentPage: true,
					pagination: {
						page,
						itemsPerPage: rowsPerPage,
						pageStart,
						pageStop,
						pageCount,
						itemsLength: totalCount,
					},
				}"
				:options.sync="options"
				:server-items-length="totalCount"
				hide-default-header
				:hide-default-footer="hideFooter"
				fixed-header
				dense
			>
				<template #header>
					<thead class="v-data-table-header">
						<tr>
							<th
								v-for="(header, index) in visibleColumns"
								:key="index"
							>
								{{ header.Header }}
							</th>
						</tr>
						<tr v-if="loadingData" class="v-data-table__progress">
							<th :colspan="visibleColumns.length" class="column">
								<v-progress-linear
									indeterminate
								></v-progress-linear>
							</th>
						</tr>
					</thead>
				</template>
				<template #body>
					<tbody v-if="!loadingData">
						<tr
							class="v-data-table__empty-wrapper"
							v-if="gridData && gridData.length == 0"
						>
							<td :colspan="visibleColumns.length + 1">
								No matching records found
							</td>
						</tr>
						<tr v-for="item in gridData" :key="item.Id">
							<td
								v-for="column in visibleColumns"
								:key="column.FieldName"
							>
								{{ item[column.FieldName] }}
							</td>
						</tr>
					</tbody>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import GridView from '../../shared/gridViews/GridView.vue';
import WorkbookReportPreviewToolbar from './WorkbookReportPreviewToolbar.vue';

export default {
	name: 'WorkbookReportPreview',
	components: { GridView, WorkbookReportPreviewToolbar },
	props: {
		filterColumns: Array,
		visibleColumns: Array,
		gridData: Array,
		irisUserMetadata: Array,
		loadingData: Boolean,
		page: Number,
		rowsPerPage: Number,
		totalCount: Number,
		quickFilter: Object,
		advancedFilter: Object,
		advancedFiltersCount: Number,
		sorting: Array,
		reportName: String,
		hasFilters: Boolean,
	},
	computed: {
		hideFooter() {
			if (this.loadingData) return true;
			if (this.gridData && this.gridData.length <= 0) return true;
			return false;
		},
		pageStart() {
			return this.rowsPerPage * (this.page - 1);
		},
		pageStop() {
			return this.rowsPerPage * this.page;
		},
		pageCount() {
			if (!this.rowsPerPage) return 0;
			if (!this.totalCount) return 0;
			let quotient = Math.floor(this.totalCount / this.rowsPerPage);
			let remainder = this.totalCount % this.rowsPerPage;
			if (remainder === 0) return quotient;
			return quotient + 1;
		},
		options: {
			get() {
				return {
					page: this.page,
					itemsPerPage: this.rowsPerPage,
				};
			},
			set(data) {
				if (this.page != data.page && !isNaN(data.page)) {
					this.onPageChanged(data.page);
				}

				if (
					this.rowsPerPage != data.itemsPerPage &&
					!isNaN(data.itemsPerPage)
				) {
					this.onRowsPerPageChanged(data.itemsPerPage);
				}
			},
		},
	},
	methods: {
		onQuickFilterChanged(e) {
			this.$emit('quickFilterChanged', e);
		},
		onAdvancedFilterChanged(e) {
			this.$emit('advancedFilterChanged', e);
		},
		onRowsPerPageChanged(e) {
			this.$emit('rowsPerPageChanged', e);
		},
		onPageChanged(e) {
			this.$emit('pageChanged', e);
		},
		onSortChanged(e) {
			this.$emit('sortChanged', e);
		},
	},
};
</script>
